import { sintegradaApi } from "@/services/api";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { PlaceOfOccurrenceEnum } from "@/utils/enums/PlaceOfOccurrenceEnum";

export type DeadPatientsByPlaceParams = {
	uf: string;
	ibgeCode: string;
	startDate: string;
	endDate: string;
	cnes?: string;
	youngerAge?: number;
	olderAge?: number;
	professionalId?: number;
	professionalCns?: string;
	professionalName?: string;
};

export async function getAggregatedDeadPatientsByPlace({
	uf,
	ibgeCode,
	...params
}: DeadPatientsByPlaceParams) {
	const response = await sintegradaApi.get<ResumeGrouped<PlaceOfOccurrenceEnum, object>[]>(
		`/uf/${uf}/city/${ibgeCode}/patient/aggregated-dead-patients-by-place`,
		params
	);
	return response.data || [];
}
